import { UserPermissions, WebSettings } from './types'

export const setWebSettings = (settings: WebSettings) =>
  ({ type: 'webSettings.setWebSettings', payload: { settings } } as const)
export type SetWebSettingsAction = ReturnType<typeof setWebSettings>

export const fetchUserPermissions = () =>
  ({ type: 'webSettings.fetchUserPermissions' } as const)
export type FetchUserPermissionsAction = ReturnType<typeof fetchUserPermissions>

export const fetchUserPermissionsSuccess = (userPermissions: UserPermissions) =>
  ({
    type: 'webSettings.fetchUserPermissionsSuccess',
    payload: userPermissions
  } as const)
export type FetchUserPermissionsSuccessAction = ReturnType<
  typeof fetchUserPermissionsSuccess
>

export type WebSettingsAction =
  | SetWebSettingsAction
  | FetchUserPermissionsAction
  | FetchUserPermissionsSuccessAction
